export async function formatEdgeFunctionError(err: unknown, fallback = 'Request failed') {
  try {
    const errObj = err as { context?: unknown; details?: unknown; message?: unknown };

    // Supabase functions errors typically expose the underlying Response as `context`.
    const res = errObj?.context;
    if (res && typeof res === 'object' && typeof (res as Response).clone === 'function') {
      const cloned = (res as Response).clone();
      const status = (res as Response).status;

      try {
        const payload = await cloned.json();
        const message =
          payload?.error ||
          payload?.message ||
          (typeof payload === 'string' ? payload : null) ||
          JSON.stringify(payload);
        return status ? `${status}: ${message}` : message;
      } catch {
        const text = await cloned.text().catch(() => '');
        const message = text || (typeof errObj?.message === 'string' ? errObj.message : '') || fallback;
        return status ? `${status}: ${message}` : message;
      }
    }

    if (typeof errObj?.details === 'string' && errObj.details.trim()) return errObj.details;
    if (typeof errObj?.message === 'string' && errObj.message.trim()) return errObj.message;
    if (typeof err === 'string' && err.trim()) return err;

    return fallback;
  } catch {
    return fallback;
  }
}
